/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */
import React, { useEffect, Fragment } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { CITY_KEY, seoTemplateType, USED_CAR_ALLOWED_CITIES, PATHS, HIDE_POPUP_FOR_URLS, DEFAULT_C2C_CITY, FALLBACK_C2B_CITY_ID } from "../../../constants/app-constants";
import useToggle from "../../../hooks/use-toggle";
import ArrowIcon from "../../shared/arrow";
import { getItem, clearItem } from "../../../utils/helpers/storage-crud";
import disableScroll from "../../../utils/helpers/disable-scroll";
import Logo from "../../shared/logo/component";
import { findByKey } from "../../../utils/helpers/find-by-key";
import addTrackingCookie from "../../../utils/helpers/add-tracking-cookie";
import { findSubstringInArrayByRegex } from "../../../utils/helpers/find-substring-in-array";
import updateCurrentCity from "../../../utils/helpers/set-current-city";
import { sendCustomGaEvents } from "../../../tracking";
import { sellMarketingBuyCarClicked } from "./tracking";

// eslint-disable-next-line complexity
const MarketingHeader = ({
    history,
    route,
    selectedCity: {
        name,
        id: selectedCityID,
        isVirtualCity,
        viewAllCarsUrl
    },
    selectCityConnect,
    templateType = "",
    cities,
    isCitySelectionSkipped,
    updateC2CPromotionFlagConnect,
    route: {
        name: routeName
    },
    isCitySelectionSSR,
    resetCitiesConnect,
    toggleLocationPickerConnect,
    pincode,
    cityInfo
}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [history]);
    const [isOpen, setIsOpen] = useToggle();
    const { pathname } = history.location;
    const hidePincodeSelector = routeName === "car-detail";
    // eslint-disable-next-line no-unused-vars
    const renderCityDropDown = () => {
        if (!findSubstringInArrayByRegex({
            haystack: HIDE_POPUP_FOR_URLS,
            needle: pathname
        }).elementExists) {
            return (
                <Fragment>
                    <p styleName={"styles.cities"} onClick={() => toggleLocationPickerConnect()}>
                        {pincode ?
                            <Fragment>
                                <label>{cityInfo && cityInfo.city_name || ""}</label>
                                {/* <label>{pincode}</label> */}
                                {/* <p>{cityInfo && cityInfo.city_name || ""}</p> */}
                            </Fragment>
                            :
                            "Select City"
                        }
                        <span><ArrowIcon orange={"OrangeArrow"} rotateBy={180} /></span>
                    </p>
                </Fragment>
            );
        }
        return null;
    };

    useEffect(() => {
        //adds utm parameters to cookie if they exist in url
        addTrackingCookie(route && route.isUsedCarRoute);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!name) {

            const currentSelectedCity = getItem(CITY_KEY);
            if (!currentSelectedCity && !isCitySelectionSkipped &&
                !(findSubstringInArrayByRegex({
                    haystack: PATHS,
                    needle: history.location.pathname
                }).elementExists) &&
                !templateType.toLowerCase().includes(seoTemplateType.CITY)) {
                setIsOpen();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setIsOpen, name, templateType, isCitySelectionSkipped]);

    useEffect(() => {
        if (!name && cities.length) {
            const currentSelectedCity = getItem(CITY_KEY);
            if (currentSelectedCity) {
                const selection = findByKey(cities, "city_id", currentSelectedCity.id);
                if (selection.city_id) {
                    selectCityConnect(
                        currentSelectedCity.id,
                        currentSelectedCity.name,
                        currentSelectedCity.image,
                        currentSelectedCity.url,
                        currentSelectedCity.viewAllCarsUrl,
                        currentSelectedCity.slug,
                        currentSelectedCity.isVirtualCity,
                        currentSelectedCity.carServiceCity,
                        currentSelectedCity.isB2CCity,
                        currentSelectedCity.isGroupCity,
                        currentSelectedCity.primaryGroupCity || null
                    );
                } else {
                    /**
                     * remove item from local storage if city isn't valid
                     * and don't select any city
                     */
                    clearItem(CITY_KEY);
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cities.length, name, selectCityConnect]);

    useEffect(() => {
        disableScroll(isOpen);
    }, [isOpen]);

    useEffect(() => {
        updateC2CPromotionFlagConnect(USED_CAR_ALLOWED_CITIES.includes(selectedCityID));
    }, [selectedCityID, updateC2CPromotionFlagConnect]);

    /**
     * if user comes from c2c to c2b via csr and delhi ncr is selected
     * reset city selection state
     */
    useEffect(() => {
        if (selectedCityID && isVirtualCity && route && !route.isUsedCarRoute) {
            resetCitiesConnect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCityID]);

    /**
     * update city with full details in website if city is selected from server
     */
    useEffect(() => {
        if (selectedCityID && isCitySelectionSSR && cities.length) {
            const selection = findByKey(cities, "city_id", selectedCityID.toString());
            if (selection.city_id) {
                updateCurrentCity(
                    cities,
                    parseInt(selection.city_id),
                    selectCityConnect,
                    false
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line complexity
    useEffect(() => {
        if (!selectedCityID && cities.length) {
            const currentSelectedCity = getItem(CITY_KEY);
            if (currentSelectedCity) {
                const selection = findByKey(cities, "city_id", currentSelectedCity.id);
                if (route && !route.isUsedCarRoute && selection.is_virtual_city) {
                    /**
                     * if user lands on a c2b page and selection is of a virtual city
                     * then set new delhi as city
                    */
                    updateCurrentCity(
                        cities,
                        parseInt(FALLBACK_C2B_CITY_ID),
                        selectCityConnect,
                        false
                    );
                } else if (route && route.isUsedCarRoute && !selection.is_buy_used_car) {
                    /**
                      * if user lands on a c2c page and selection is of a non c2c city,
                      * then select delhi ncr as default city
                     */
                    updateCurrentCity(
                        cities,
                        parseInt(DEFAULT_C2C_CITY.id),
                        selectCityConnect,
                        false
                    );
                } else {
                    /**
                     * assume current selected city is a valid city for any case
                     * proceed to reducer population
                    */
                    updateCurrentCity(
                        cities,
                        parseInt(currentSelectedCity.id),
                        selectCityConnect,
                        false
                    );
                }
            }
        } else if (selectedCityID && isVirtualCity && route && !route.isUsedCarRoute) {
            updateCurrentCity(
                cities,
                parseInt(FALLBACK_C2B_CITY_ID),
                selectCityConnect,
                false
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cities.length, selectedCityID, selectCityConnect]);

    const onBuyCarClick = () => {
        sendCustomGaEvents(sellMarketingBuyCarClicked);
        if (viewAllCarsUrl) {
            window.location.href = viewAllCarsUrl;
        }
    };
    const isOfferPage = history.location.pathname.match("/offer/*");
    return (
        <div >
            <div>
                <div styleName={"styles.mainHeader"}>
                    <div className={"container"}>
                        <div className={"row"}>
                            <div className={"col-md-3"} styleName="styles.logoWrapper">
                                <div
                                    className={"d-inline-block"}
                                    styleName={"styles.logo"}
                                >
                                    <Logo />
                                </div>
                                {
                                    !hidePincodeSelector && renderCityDropDown()
                                }
                            </div>
                            <div className={"col-md-9"}>
                                {!isOfferPage && <div styleName={"styles.headerRight"}>
                                    {
                                        !!(cityInfo && cityInfo.is_buy_used_car) &&
                                        <button onClick={onBuyCarClick}>BUY CAR</button>
                                    }
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

MarketingHeader.propTypes = {
    history: PropTypes.object.isRequired,
    selectedCity: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        image: PropTypes.string,
        url: PropTypes.string,
        slug: PropTypes.string,
        isVirtualCity: PropTypes.bool,
        viewAllCarsUrl: PropTypes.string
    }),
    selectCityConnect: PropTypes.func,
    templateType: PropTypes.string,
    isCitySelectionSkipped: PropTypes.bool,
    cities: PropTypes.array,
    updateC2CPromotionFlagConnect: PropTypes.func,
    route: PropTypes.object,
    isCitySelectionSSR: PropTypes.bool,
    resetCitiesConnect: PropTypes.func,
    toggleLocationPickerConnect: PropTypes.func,
    pincode: PropTypes.number,
    cityInfo: PropTypes.object
};

export default MarketingHeader;

